import React from "react";
import { Trans } from "react-i18next";

import { Link } from "react-router-dom";



const Footer = () => (
  <div className="footer pb-0" id="Contact Us">
    <div className="theone">
      <footer className="dark-footer footer-info">
        <div className="container px-5">
          <div className="row">
            <div className="col-lg-8 col-md-8 pt-4">
              <div>
                <img src="/images/logo2.svg" alt="#" style={{ maxHeight: "auto", width: "70px", paddingBottom: "20px" }} />
                <div className="social-media">
                  <a href="https://www.instagram.com/ea_compny/">
                    <img src="/images/social-icons.svg" alt="#" />
                  </a>
                  <a href="https://www.linkedin.com/company/%D8%B4%D8%B1%D9%83%D8%A9-%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B1%D9%8A%D8%A7%D8%AF%D8%A9-%D8%A7%D9%84%D9%85%D8%AD%D8%AF%D9%88%D8%AF%D8%A9">
                    <img src="/images/linkedin.svg" alt="#" />
                  </a>
                  <a href="https://twitter.com/EA_Company?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor">
                    <img src="/images/icons8-twiterx.svg" alt="#" />
                  </a>
                  <a href="https://www.youtube.com/channel/UCNdZ2Xn1zJXw77L92nyRveg">
                    <img src="/images/social-icons3.svg" alt="#" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 pt-4">
              <div className="reach-us">
                <h4><Trans>Reach us</Trans></h4>
                <ul>
                  <li className="d-flex">
                    <div style={{ flex: '1' }} class="text-center">
                      <i class="fa fa-envelope" aria-hidden="true" style={{ fontSize: '1.5rem' }}></i>
                    </div>
                    <div style={{ flex: '20' }}>
                      <a href="mailto:xero@wpholding.com">
                        <span className="mx-2"><Trans>xero@wpholding.com</Trans></span>
                      </a>
                    </div>
                  </li>
                  <li className="d-flex">
                    <div style={{ flex: '1' }} class="text-center">
                      <i class="fa fa-mobile" aria-hidden="true" style={{ fontSize: '1.5rem' }}></i>
                    </div>
                    <div style={{ flex: '20' }}>
                      <span className="mx-2" dir="ltr">+966 53 466 684</span>
                    </div>
                  </li>
                  <li className="d-flex">
                    <div style={{ flex: '1' }} class="text-center">
                      <i className="fa fa-map" aria-hidden="true" style={{ fontSize: '1.5rem' }}></i>
                    </div>
                    <div style={{ flex: '20' }}>
                      <span className="mx-2"><Trans>P.O.Box 261964, Riyadh 11342, Kingdom of Saudi Arabia</Trans></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div className="terms">
            <div className="row justify-content-between">
              <div className="col-6">
                <p className="footer-info text-left">
                  <Trans year={new Date().getFullYear()}>
                    <span>© {{ year: new Date().getFullYear() }} - Hesaab </span><a href="https://wpholding.com/"><span style={{ color: "#72B566" }}>- Wealth Preservation Holding Company</span> </a>
                  </Trans>

                </p>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <ul className="terms-links d-flex text-nowrap">
                  <li><a href="/Terms-Conditions"><Trans>Terms & Conditions</Trans></a></li>
                  <li><a href="#">|</a></li>
                  <li><a href="/privacy_policy"><Trans>Privacy Policy</Trans></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
);

export default Footer;
